export default "__VITE_ASSET__kxFYIb1T__"